module.exports = __webpack_public_path__ + "static/media/Spin.7397cceb.gif";